import { render } from "./PaiementKKiaPay.vue?vue&type=template&id=123e669c&scoped=true&ts=true"
import script from "./PaiementKKiaPay.vue?vue&type=script&lang=ts"
export * from "./PaiementKKiaPay.vue?vue&type=script&lang=ts"

import "./PaiementKKiaPay.vue?vue&type=style&index=0&id=123e669c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123e669c"]])

export default __exports__